import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="text-white py-5 mt-5" style={{ 
      background: 'linear-gradient(135deg, #0B1F3F 0%, #1E3A8A 50%, #0078D4 100%)'
    }}>
      <Container>
        <Row className="gy-4">
          <Col lg={5}>
            <h3 className="mb-3 fw-bold">Beniamin Kwak</h3>
            <p className="mb-3" style={{ opacity: 0.9 }}>
              Azure DevOps Engineer specializing in cloud infrastructure automation, 
              CI/CD pipelines, and Azure services optimization.
            </p>
            <div className="d-flex gap-3 mb-3">
              <a 
                href="https://www.linkedin.com/in/beniaminkwak/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white"
                style={{ fontSize: '1.5rem', transition: 'all 0.3s ease' }}
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a 
                href="https://github.com/kwakbeniamin" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white"
                style={{ fontSize: '1.5rem', transition: 'all 0.3s ease' }}
              >
                <i className="bi bi-github"></i>
              </a>
              <a 
                href="https://www.youtube.com/@beniaminkwak" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white"
                style={{ fontSize: '1.5rem', transition: 'all 0.3s ease' }}
              >
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </Col>

          <Col lg={3} className="ms-auto">
            <h4 className="mb-3 fw-bold">Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#experience" className="text-white text-decoration-none" style={{ opacity: 0.9 }}>
                  <i className="bi bi-arrow-right me-2"></i>Experience
                </a>
              </li>
              <li className="mb-2">
                <a href="#youtube" className="text-white text-decoration-none" style={{ opacity: 0.9 }}>
                  <i className="bi bi-arrow-right me-2"></i>YouTube Videos
                </a>
              </li>
              <li>
                <a 
                  href={process.env.REACT_APP_CV_DOWNLOAD_URL || '#'} 
                  className="text-white text-decoration-none"
                  style={{ opacity: 0.9 }}
                  download="Beniamin-Kwak-CV.pdf"
                >
                  <i className="bi bi-arrow-right me-2"></i>Download CV
                </a>
              </li>
            </ul>
          </Col>

          <Col lg={3}>
            <h4 className="mb-3 fw-bold">Contact</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a 
                  href="mailto:beniaminkwak@gmail.com" 
                  className="text-white text-decoration-none"
                  style={{ opacity: 0.9 }}
                >
                  <i className="bi bi-envelope me-2"></i>Email Me
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        
        <hr style={{ borderColor: 'rgba(255,255,255,0.2)', marginTop: '2rem', marginBottom: '2rem' }} />
        
        <Row>
          <Col className="text-center">
            <p className="mb-0" style={{ opacity: 0.8 }}>
              © {new Date().getFullYear()} Beniamin Kwak - Made with 💙 and Azure
            </p>
            <p className="mt-2 mb-0" style={{ opacity: 0.6, fontSize: '0.9rem' }}>
              Hosted on Azure Static Web Apps | Powered by Azure Functions
            </p>
          </Col>
        </Row>
      </Container>
      
      <style>
        {`
          footer a:hover {
            opacity: 1 !important;
            transform: translateX(5px);
            transition: all 0.3s ease;
          }
          
          footer a i.bi {
            transition: all 0.3s ease;
          }
          
          footer a:hover i.bi {
            transform: scale(1.2);
          }
        `}
      </style>
    </footer>
  );
}

export default Footer;